{
  const THROTTLE_MS = 200;

  let isLoading = false;
  let nextPageUrl = null;
  let sectionId = null;
  let wrapper = null;
  let productGrid = null;
  let throttleTimer = null;
  let scrollHandler = null;
  const loadedUrls = new Set();

  function getScrollThreshold() {
    return window.innerWidth * 2;
  }

  function init() {
    wrapper = document.querySelector('.js-horizontal-scroll-wrapper');
    productGrid = document.getElementById('product-grid');

    if (!wrapper || !productGrid) return;

    sectionId = productGrid.dataset.id;

    // Reset state
    isLoading = false;
    nextPageUrl = null;
    loadedUrls.clear();

    // Remove previous listener if re-initializing
    if (scrollHandler) {
      wrapper.removeEventListener('scroll', scrollHandler);
    }

    // Extract next page URL from hidden pagination
    updateNextPageUrl(document);

    if (!nextPageUrl) return;

    scrollHandler = onScroll;
    wrapper.addEventListener('scroll', scrollHandler, { passive: true });
  }

  function updateNextPageUrl(root) {
    // The "next" link has class pagination__item--prev (due to icon rotation naming in this theme)
    const paginationContainer = root.querySelector('.infinite-scroll-pagination');
    if (!paginationContainer) {
      nextPageUrl = null;
      return;
    }

    const nextLink = paginationContainer.querySelector('.pagination__item--prev');
    if (nextLink) {
      const href = nextLink.getAttribute('href');
      // Prevent loading the same URL twice
      if (loadedUrls.has(href)) {
        nextPageUrl = null;
      } else {
        nextPageUrl = href;
      }
    } else {
      nextPageUrl = null;
    }
  }

  function stopListening() {
    if (scrollHandler && wrapper) {
      wrapper.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
  }

  function onScroll() {
    if (isLoading || !nextPageUrl || throttleTimer) return;

    throttleTimer = setTimeout(() => {
      throttleTimer = null;

      const scrollRight = wrapper.scrollWidth - wrapper.scrollLeft - wrapper.clientWidth;

      if (scrollRight <= getScrollThreshold()) {
        loadNextPage();
      }
    }, THROTTLE_MS);
  }

  async function loadNextPage() {
    if (isLoading || !nextPageUrl) return;

    const currentUrl = nextPageUrl;

    // Guard: skip if already loaded
    if (loadedUrls.has(currentUrl)) {
      nextPageUrl = null;
      stopListening();
      return;
    }

    isLoading = true;
    loadedUrls.add(currentUrl);

    try {
      // Build section rendering URL
      const url = new URL(currentUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Extract product items (exclude collection images which are metafield-based)
      const fetchedGrid = doc.getElementById('product-grid');
      if (!fetchedGrid) {
        nextPageUrl = null;
        stopListening();
        return;
      }

      const newItems = fetchedGrid.querySelectorAll(':scope > li.grid__item:not(.collection__image)');

      if (newItems.length === 0) {
        nextPageUrl = null;
        stopListening();
        return;
      }

      // Append new product items to current grid
      newItems.forEach((item) => {
        productGrid.appendChild(item);
      });

      // Update next page URL from fetched pagination
      updateNextPageUrl(doc);

      // If no more pages, stop listening
      if (!nextPageUrl) {
        stopListening();
      }

      // Resize Lenis to recalculate scroll bounds
      requestAnimationFrame(() => {
        if (wrapper.__lenis) {
          wrapper.__lenis.resize();
        }
      });
    } catch (error) {
      console.error('[infinite-scroll] Failed to load next page:', error);
      // On error, remove the URL from loaded set so it can be retried
      loadedUrls.delete(currentUrl);
    } finally {
      isLoading = false;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize after facet filter changes
  // facets.js replaces ProductGridContainer innerHTML (direct children change),
  // so we only watch direct childList — NOT subtree — to avoid
  // re-triggering when we appendChild products to #product-grid.
  const observer = new MutationObserver(() => {
    setTimeout(init, 100);
  });

  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    observer.observe(gridContainer, { childList: true, subtree: false });
  }
}
